import {defineMessages} from 'react-intl';

export default defineMessages({
	preOrder: {
		id: 'productTile.preOrder',
		defaultMessage: 'Preorder',
	}
});
